import moment from "moment";

export const DEFAULT_TIMESEARCH = {
    startDate: moment().clone().weekday(1).startOf('day'),
    endDate: moment().clone().weekday(7).endOf('day'),
    recordingPage: {
        startDate: moment().clone().startOf('day').subtract(7, 'days'),
        endDate: moment().clone().startOf('day'),
    },
    landingPage: {
        startDate: moment().clone().startOf('day'),
        endDate: moment().clone().startOf('day').add(30, 'days'),
    },
    accessLogPage: {
        startDate: moment().clone().startOf('day').subtract(7, 'days'),
        endDate: moment().clone().endOf('day'),
    }
}